// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { FormattedMessage, intlShape } from 'react-intl';
import RadioButton from '../../../../../elements/RadioButton/RadioButton';
import { scroller } from 'react-scroll';
import { Element } from 'react-scroll/modules';
import Checkbox from '../../../../../elements/Checkbox/Checkbox';

import icons from '../../../../../assets/styles/icons.scss';
import loadingCircle from '../../../../../assets/img/loading_circle.gif';
import style from './PaymentMethod.scss';
import bcp from '../../../../../assets/img/home/pay-methods/bcp.png';
import interbank from '../../../../../assets/img/home/pay-methods/interbank.png';
import bbva from '../../../../../assets/img/home/pay-methods/bbva.png';
import scotiabank from '../../../../../assets/img/home/pay-methods/scotiabank.png';

import type { PaymentImpl } from "../../PaymentImpl";
import type { PaymentExecuteUIError } from '../../duck';

type Props = {
  +paymentMethod: {
    value: string;
  };
  +paymentMethods?: { [key: string]: string };
  +isFetchingPaymentMethods?: boolean;
  +handleChangePaymentMethod: (value: string, name: string) => void;
  +country: {
    value: string;
    errors?: string[];
  };
  +paymentImplementation: ?PaymentImpl;
  +paymentExecuteUIError?: PaymentExecuteUIError;
  +isCreatingToken?: boolean;
  +deliveryAddressHasError?: boolean;
  +acceptTerms: boolean;
  +handleChangeTerms: (e: Event) => void;
};

const paymentMethodIntlMap = {
  CARD: {
    intl: 'checkout.paymentMethod.card',
    icon: icons.iconCashCardLight,
  },
  CREDIT_CARD: {
    intl: 'checkout.paymentMethod.credit',
    icon: icons.iconCreditCardLight,
  },
  DEBIT_CARD: {
    intl: 'checkout.paymentMethod.debit',
    icon: icons.iconDebitCardLight,
  },
  PAYPAL: {
    intl: 'checkout.paymentMethod.paypal',
    icon: icons.symbolPaypal,
  },
  CASH: {
    intl: 'checkout.paymentMethod.cash',
    icon: icons.iconWalletCashLight,
  },
  TRANSFER: {
    intl: 'checkout.paymentMethod.deposit',
    icon: icons.symbolWiredTransfer,
  },
  MANUAL_TRANSFER: {
    intl: 'checkout.paymentMethod.manualDeposit',
    icon: icons.symbolWiredTransfer,
  },
  MANUAL_TRANSFER_SOLES: {
    intl: 'checkout.paymentMethod.manualDepositSoles',
    icon: icons.symbolWiredTransfer,
  },
  CRYPTO: {
    intl: 'checkout.paymentMethod.crypto',
    icon: icons.symbolBitcoin,
  },
  AMAZON: {
    intl: 'checkout.paymentMethod.amazon',
    icon: icons.symbolBank,
  },
  DINERS: {
    intl: 'checkout.paymentMethod.diners',
    icon: icons.iconCashCardLight,
  },
};

const DEFAULT_PAYMENT_METHODS = {
  CARD: 'NIUBIZ_WEB', // 3 cuotas 
  CREDIT_CARD: 'CULQI',
  CRYPTO: 'BITPAY',
  DEBIT_CARD: 'CULQI', // 3 cuotas BCP
  PAYPAL: 'PAYPAL',
  TRANSFER: 'KASHIO',
  MANUAL_TRANSFER: 'MANUAL_TRANSFER',
  MANUAL_TRANSFER_SOLES: 'MANUAL_TRANSFER_SOLES',
};

const SCROLL_OPTIONS = {
  duration: 350,
  delay: 0,
  smooth: 'easeInOutQuart',
  offset: -400,
};

export default class PaymentMethod extends Component<Props, void> {
  //paymentImplementation: ?PaymentImpl;

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.paymentExecuteUIError) {
      scroller.scrollTo('paymentUI', SCROLL_OPTIONS);
    }
  }

  getPaymentMethodIntl(key: string): string {
    const { country } = this.props;
    if (key === 'TRANSFER' && country.value === 'CO') {
      return 'checkout.paymentMethod.deposit.CO';
    }
    return paymentMethodIntlMap[key].intl;
  }

  handleChangeSelect = (e: SyntheticInputEvent<HTMLInputElement>) => {
    if (e.target instanceof HTMLInputElement) {
      const { handleChangePaymentMethod } = this.props;
      const { name, value } = e.target;
      handleChangePaymentMethod(value, name);
    }
  };

  render() {
    const {
      paymentMethods, paymentMethod, isFetchingPaymentMethods, paymentImplementation,
      isCreatingToken, deliveryAddressHasError, country,
      acceptTerms,
      handleChangeTerms,
    } = this.props;
    const methods = paymentMethods || DEFAULT_PAYMENT_METHODS;
    const methodsContent = Object.keys(methods).map((key: string) => {
      return (
        <Fragment key={key}>
          <RadioButton name={methods[key]}
                       value={key}
                       selected={paymentMethod.value}
                       color="lightBlue"
                       disabled={/*key === 'DEBIT_CARD' || */methods[key] === 'DISABLED' || isCreatingToken}
                       handleChange={this.handleChangeSelect}>
            <FormattedMessage id={this.getPaymentMethodIntl(key)}>{
              txt => <span className={classNames(style.methodName, { [style.selected]: paymentMethod.value === key })}>
              <i className={classNames(paymentMethodIntlMap[key].icon, style.methodIcon)}/>{txt}</span>
            }</FormattedMessage>
          </RadioButton>
          {key === 'DINERS' && paymentMethod.value === 'DINERS' &&
          <FormattedMessage id="checkout.paymentMethod.diners.message">{
            txt => <p
              className={classNames(style.paymentMethodMessage, { [style.disabled]: isCreatingToken })}>{txt}</p>
          }</FormattedMessage>}
          {(
            (key === 'MANUAL_TRANSFER' && paymentMethod.value === 'MANUAL_TRANSFER') || 
            (key === 'MANUAL_TRANSFER_SOLES' && paymentMethod.value === 'MANUAL_TRANSFER_SOLES')
           ) && country.value === 'PE' &&
            <section className={classNames(style.banks,
              { [style.paymentImplLoading]: isCreatingToken || deliveryAddressHasError })}>
              <img src={bcp} alt="bcp"/>
              {/*<img src={interbank} alt="interbank"/>
          <img src={bbva} alt="bbva"/>
          <img src={scotiabank} alt="scotiabank"/>*/}
            </section>}

          {/*{key === 'DEBIT_CARD' && (
            <span className={classNames(style.disabledTemporarily, { [style.disabled]: isCreatingToken })}>Deshabilitada temporalmente.</span>
          )}*/}

          {((paymentMethod.value === 'CARD' && key === 'CARD')/* || (paymentMethod.value === 'DEBIT_CARD' && key === 'DEBIT_CARD')*/) && (
            <span className={classNames(style.installments, { [style.disabled]: isCreatingToken })}>Recuerda seleccionar las cuotas al ingresar el número de tu tarjeta.</span>
          )}
        </Fragment>);
    });

    let customUI = null;
    try {
      customUI = !!paymentImplementation && paymentImplementation.generateCustomUI();
    } catch (e) {
      console.error(e);
      console.log('error customUI', customUI);
    }

    return (
      <section className={classNames(style.paymentBox,
        { [style.disabled]: !paymentMethods || isFetchingPaymentMethods || deliveryAddressHasError })}>
        <FormattedMessage id="checkout.paymentMethod.title">{
          txt => (<h2 className={classNames(style.title,
            { [style.paymentImplLoading]: isCreatingToken || deliveryAddressHasError })}>2. {txt}</h2>)
        }</FormattedMessage>
        <FormattedMessage id="checkout.paymentMethod.subtitle">{
          txt => (<label className={classNames(style.label,
            { [style.paymentImplLoading]: isCreatingToken || deliveryAddressHasError })}>{txt}</label>)
        }</FormattedMessage>
        {isCreatingToken && <img className={style.loading} src={loadingCircle} alt=""/>}
        {methodsContent}
        {paymentMethod.value === 'CARD' &&
        <div className={classNames(style.niubizCheckbox, { [style.disabled]: isCreatingToken })}>
          <Checkbox
            isChecked={acceptTerms}
            name="acceptTerms"
            value="acceptTerms"
            disabled={isCreatingToken}
            handleChange={handleChangeTerms}
          >
            <p>
              {this.context.intl.formatMessage({ id: 'checkout.paymentMethod.niubiz.t&c.one' })}&nbsp;
              <Link to="/terms-of-service">
                {this.context.intl.formatMessage({ id: 'checkout.paymentMethod.niubiz.t&c.two' })}
              </Link>&nbsp;
              {this.context.intl.formatMessage({ id: 'checkout.paymentMethod.niubiz.t&c.three' })}
            </p>
          </Checkbox>
        </div>
        }
        {paymentImplementation &&
        <section className={classNames({ [style.paymentImplLoading]: isCreatingToken })}>
          <Element name="paymentUI">
            {customUI}
          </Element>
        </section>}
      </section>);
  }

}

PaymentMethod.propTypes = {
  paymentMethod: PropTypes.object.isRequired,
  paymentMethods: PropTypes.object,
  isFetchingPaymentMethods: PropTypes.bool,
  handleChangePaymentMethod: PropTypes.func.isRequired,
  country: PropTypes.object.isRequired,
  paymentImplementation: PropTypes.object,
  isCreatingToken: PropTypes.bool,
  deliveryAddressHasError: PropTypes.bool,
  paymentExecuteUIError: PropTypes.object,
  acceptTerms: PropTypes.bool.isRequired,
  handleChangeTerms: PropTypes.func.isRequired,
};

PaymentMethod.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/components/PaymentMethod/PaymentMethod.jsx